/*
*
* File JS componente BLOCK SPONSOR
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import './block-sponsor.scss';
import Swiper, {Navigation, Pagination, Autoplay} from "swiper";

//--------------------------------------------------------------------//

// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const initSponsorSwiper = () => {
    let elSwiperSponsor = document.querySelector('.block-sponsor .swiper-container');

    if (!elSwiperSponsor) {
        return;
    }

    Swiper.use([Navigation, Pagination, Autoplay]);

    const args = {
        initialSlide: 1,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        speed: 2000,
        centeredSlides: false,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            reverseDirection: false,
        },
        navigation: {
            nextEl: '.swiper-button-next.next',
            prevEl: '.swiper-button-prev.prev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
        breakpoints: {
            320: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            768: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            },
            1024: {
                slidesPerView: 8,
                slidesPerGroup: 8,
            },
        }
    };

    let swiperMag = new Swiper(elSwiperSponsor, args);
}

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockSponsor = () => {

    initSponsorSwiper();

}

export default blockSponsor;

//--------------------------------------------------------------------//